<template>
  <div class="dropzone-container rounded p-2" :style="{ height: height + 'px', width: width + 'px' }" v-bind="getRootProps()">
    <input v-bind="getInputProps()"/>
    <p v-if="isDragActive">Drop the files here ...</p>
    <p v-else><span v-if="displayText">{{ text }}</span></p>

    <ul v-if="modelValue" class="file-list d-flex">
      <li v-for="(file, index) in modelValue" :key="index" class="mt-2">
        <img width="50" height="50" :class="getFileType(file.name).iconClass" :src="getFileType(file.name).imgSrc"
             alt="File Icon"><br/>
        {{ file.name }} ({{ formatSize(file.size) }})
      </li>
    </ul>
  </div>
</template>

<script setup>
import { getFileType } from '@/shared/functions';
import { computed, defineEmits, defineProps, toRefs } from 'vue';
import { useDropzone } from 'vue3-dropzone';

const props = defineProps({
  modelValue: {
    type: [ String, Number, null ],
    required: true,
  },
  multiple: {
    type: Boolean,
    default: true, // Allow multiple files by default
  },
  text: {
    type: String,
    default: 'Ziehen Sie einige Dateien per Drag & Drop hierher, oder klicken Sie zum Auswählen',
  },
  height: {
    type: [ String, Number ],
  },
  width: {
    type: [ String, Number ],
  },
});

const modelValue  = toRefs(props)[ 'modelValue' ];
const emit        = defineEmits([ 'update:modelValue' ]);

const displayText = computed(() => {
  const value = modelValue.value;

  if (!value) {
    return true
  }

  // Single file object
  if (value instanceof File) {
    return false;
  }

  // Array of files
  if (Array.isArray(value) && value.length > 0 && value[ 0 ] instanceof File) {
    return false;
  }

  // Not a file or unrecognized
  return true;
});

const onDrop = (acceptedFiles, rejectedFiles) => {
  emit('update:modelValue', acceptedFiles);
};

const { getRootProps, getInputProps, isDragActive } = useDropzone({
  onDrop,
  multiple: props.multiple, // Enable or disable multiple file selection
});

const formatSize = (size) => {
  return size < 1024
      ? `${size} B`
      : size < 1024 * 1024
          ? `${(size / 1024).toFixed(1)} KB`
          : `${(size / (1024 * 1024)).toFixed(1)} MB`;
};
</script>

<style scoped>
.dropzone-container {
  border: 2px dashed #ccc;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: background 0.3s;
}

.dropzone-container:hover {
  /* background: #e8f5e9; */
}

.file-list {
  gap: 24px;
  margin-top: 10px;
  padding: 0;
  list-style: none;
  flex-wrap: wrap;
}

.file-list li {
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  font-size: 14px;
}
</style>
  